export default {
  viewType: 'rows',
  groupTypes: [],
  groupType: null,
  groupItem: null,
  groupItems: [],
  groupByOptions: [],
  groupBy: null,
  viewBy: null,
  taxExpenseLoading: false,
  isFetchingGroupTypes: false,
  isFetchingGroupItems: false,
  isFetchingCountryTaxTypes: false,
  isFetchingStatutoryTaxRates: false,
  isFetchingReportData: false,
  allCountryTaxTypesAndRates: [],
  selectedCountryTaxTypes: [],
  statutoryTaxRate: null,
  reportData: null,
  companyCodes: [],
  ETRGroups: [],
  isSavingData: false,
  countryTaxTypesETR: [],
  countryTaxTypesForCompanyCode: [],
  selectedCell: null,
};
